import React from 'react';
import { ArrowRight } from 'lucide-react';
interface BannerProps {
  title: string;
  description: string;
  ctaText: string;
  image: string;
}
interface SmartBannerProps {
  banner: BannerProps;
  size?: 'small' | 'medium' | 'large';
}
export const SmartBanner: React.FC<SmartBannerProps> = ({
  banner,
  size = 'medium'
}) => {
  const {
    title,
    description,
    ctaText,
    image
  } = banner;
  const getHeightClass = () => {
    switch (size) {
      case 'small':
        return 'h-24';
      case 'large':
        return 'h-48';
      case 'medium':
      default:
        return 'h-32';
    }
  };
  return <div className={`w-full ${getHeightClass()} rounded-lg overflow-hidden relative group`} data-id="element-21655">
      {/* Background image with overlay */}
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: `url(${image})`
    }} data-id="element-21656">
        <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-colors" data-id="element-21657"></div>
      </div>
      {/* Content */}
      <div className="absolute inset-0 p-4 flex flex-col justify-center text-white" data-id="element-21658">
        <h3 className={`font-bold ${size === 'small' ? 'text-lg' : 'text-xl'} mb-1`} data-id="element-21659">
          {title}
        </h3>
        <p className={`${size === 'small' ? 'text-xs' : 'text-sm'} text-white/90 mb-3 line-clamp-2`} data-id="element-21660">
          {description}
        </p>
        <button className="mt-auto self-start flex items-center gap-1.5 bg-white text-gray-900 hover:bg-gray-100 px-3 py-1.5 rounded-md text-sm font-medium transition-colors" data-id="element-21661">
          {ctaText}
          <ArrowRight size={14} data-id="element-21662" />
        </button>
      </div>
    </div>;
};